<template>
    <div v-if="showcontenedor" class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
          <Menu></Menu>
        <div class="wrapper d-flex flex-column flex-row-fluid" >
        <Header></Header>
         <div  class="container-xxl">
          <!--begin::Card-->
          <div class="card">
            <!--begin::Card header-->
            <div class="card-header border-0 pt-6">
              <!--begin::Card title-->
              <div class="card-title">
                <!--begin::Search-->
                <div class="d-flex align-items-center position-relative my-1">
                  <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                  <span class="svg-icon svg-icon-1 position-absolute ms-6">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
                      <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <input type="text" class="form-control form-control-solid w-250px ps-14"
                    placeholder="Buscar cargo" v-model="Buscar"/>
                </div>
                <!--end::Search-->
              </div>
              <!--begin::Card title-->
              <!--begin::Card toolbar-->
              <div class="card-toolbar">
                <!--begin::Toolbar-->
                <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
                  <!--begin::Add user-->
                  <button type="button" class="btn btn-primary" @click="AbrirModal('', 'mAgregar'),obtenerPermiso()">
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr075.svg-->
                    <span class="svg-icon svg-icon-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="currentColor"/>
                        <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="currentColor"/>
                      </svg>
                    </span>
                    <!--end::Svg Icon-->Agregar Cargo
                  </button>
                  <!--end::Add user-->
                </div>
                <!--begin::Modal - Add task-->
                <div class="modal fade" id="kt_modal_edit_cargo" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                  <!--begin::Modal dialog-->
                  <div class="modal-dialog modal-dialog-centered mw-650px">
                    <Cargomodal
                      v-if="showModal"
                      :TipoModal="this.TipoModal"
                      :CargoID="this.CargoID"
                      :Nombre="this.Nombre"
                      :UsuarioID="this.UsuarioID"
                    ></Cargomodal>
                  </div>
                </div>
                <!--end::Modal - Add task-->
              </div>
              <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body py-4">
              <!--begin::Table-->
              <div class="table-responsive">
                <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_users">
                  <!--begin::Table head-->
                  <thead>
                    <!--begin::Table row-->
                    <tr class=" text-center text-muted fw-bold fs-7 text-uppercase gs-0">
                      <th class="min-w-150px">Cargo</th>
                      <th class="min-w-130px">Fecha Creación</th>
                      <th class="text-center min-w-170px">Acciones</th>
                    </tr>
                    <!--end::Table row-->
                  </thead>
                  <!--end::Table head-->
                  <!--begin::Table body-->
                  <tbody class="text-gray-600 fw-semibold">
                    <!--begin::Table row-->
                    <tr v-for="(lstcargo, index) in buscarCargo" :key="index">
                      <!--begin::User=-->
                      <td class="align-items-center">
                        <!--begin:: Avatar -->
                      
                        <!--end::Avatar-->
                        <!--begin::User details-->
                        <div class="d-flex flex-column">
                          <a class="text-gray-800 text-hover-primary mb-1">{{ lstcargo.Nombre }}</a>
                          <!-- <span>{{lstcargo.correo}}</span> -->
                        </div>
                        <!--begin::User details-->
                      </td>
        
                   
                      <td> 
                          {{getDateFormat(lstcargo.FechaRegistro)  }}
                      </td>
                      <!--end::Two step=-->
                      <!--begin::Action=-->
                      <td class="text-end">
                        <div class="text-center justify-content-center flex-shrink-0">
                        
                        <button type="button" @click="AlerEliminarCargo(lstcargo)" class="btn btn-danger btn-hover-scale btn-sm btn-icon me-1" >
                         <i class="fas fa-trash"></i>
                        </button >
                      </div>
                      </td>

                      <!--end::Action=-->
                    </tr>
                    <!--end::Table row-->
                  </tbody>
                  <!--end::Table body-->
                </table>
              </div>
              <!--end::Table-->
            </div>
            <!--end::Card body-->
          </div>
          <!--end::Card-->
        </div>

        </div>
    </div>
  </div>
</template>
<script lang="js">
import { defineComponent } from 'vue'
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Cargomodal from '@/components/Cargomodal.vue'
import axios from 'axios'
export default defineComponent( {
  name: 'Cargo',
  components: {
    Menu,
    Header,
    Cargomodal
  },
  data() {
    return {
         BASE_URL: process.env.VUE_APP_BASE_URL,
        listado_cargo:[],
        TipoModal:"",
         TOKEN:'',
         MODIFICADOR:'',
         Buscar:'',
         UsuarioID:"",
         CargoID:"",
         Nombre:"",
          showModal: false,
          showcontenedor:false,
    }
  },
  mounted() {
    this.obtenerPermiso();
  },
 created() {
  this.validacionStorage();
    this.obtenerCargo()
 },
 
computed:{
    buscarCargo() {
     return this.listado_cargo.filter(item => {
                return item.Nombre.toLowerCase().includes(this.Buscar.toLowerCase());
                 });   
       }
    },

methods: {
       obtenerPermiso(){
               var pathname = window.location.pathname,firstObj=null, lista_mod=[];
               lista_mod= JSON.parse(localStorage.getItem('Modulos'))
               var results = lista_mod.filter(modulo => modulo.Ruta === pathname);
               firstObj = (results.length > 0) ? results[0] : null;
               if(firstObj== null || firstObj== ""){
                this.showcontenedor=false
                window.location.href = "/home"
                }else{
                  this.showcontenedor=true
                }
           },
	validacionStorage(){
                 this.TOKEN = JSON.parse(localStorage.getItem('TOKEN'));
                  this.MODIFICADOR = JSON.parse(localStorage.getItem('user-ID'));
                if(this.TOKEN ===  null){
                window.location.href = "/login"
                }
              },
            getDateFormat(fecha) {
    return moment(fecha).format("DD/MM/YYYY hh:mm a");
  },
    obtenerCargo: function(){
         axios.get(this.BASE_URL+"/cargo/listar",{headers:{'Authorization': this.TOKEN}})
        .then((response) => {
          this.listado_cargo = response.data.respuesta;
        });
    },
     AbrirModal({CargoID,Nombre,UsuarioID},TipoModal){
        this.TipoModal = TipoModal
        this.CargoID = CargoID
        this.Nombre = Nombre
        this.UsuarioID = UsuarioID
        this.showModal=true
         $('#kt_modal_edit_cargo').modal('show')
      },
 AlerEliminarCargo({CargoID}){
          Swal.fire({
        text: "Estás seguro de que deseas Eliminar? ",
        icon: "error",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Si, Eliminar!",
        cancelButtonText: "No, Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
          cancelButton: "btn fw-bold btn-active-light-primary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
              this.EliminarCargo({CargoID});
          Swal.fire({
            text: "Se Eliminó correctamente",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Aceptar!",
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
            },
          }).then((result) =>  {
             if (result.isConfirmed) {
               window.location.href = "/cargo";
             }
          
           
          });
        } else if (result.dismiss === "cancel") {
          Swal.fire({
            text: "No se eliminó",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Aceptar!",
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
            },
          }).then(function () {
          });
        }
      });
      },
         EliminarCargo: function({CargoID}){
        this.CargoID = CargoID
        axios.post(this.BASE_URL+"/cargo/eliminar", {
          CargoID: this.CargoID,
          UsuarioID: this.MODIFICADOR,
        },{headers:{'Authorization': this.TOKEN}})
        .then((response) => {
            window.location.href = "/cargo"
        });

      },

}
})
</script>